import React from 'react';

import "../stylesheets/ProjectSection.css"


// IndividualProject component
function IndividualProject(props) {
    const { projectRole, projectTitle, techSkills, projectRoute, projectDescription, projectImages } = props;

    return (
        <div className="individual-project">
            <div className="project-role">{projectRole}</div>
            <h1 className="project-name">{projectTitle}</h1>

            <ul className="skills-used">
                {techSkills.map((skill) => (
                    <li key={skill} className="skill-box">{skill}</li>
                ))}
            </ul>
            <div className="project-button">
                <a tabIndex="0" href={projectRoute}>View Project</a>
                <a tabIndex="1" href={projectRoute}>View Project</a>
            </div>
            <p className="project-description" dangerouslySetInnerHTML={{ __html: projectDescription }}></p>

            <div className="project-image-container">
                {projectImages.map((image) => {
                    return (
                        <a href={projectRoute} key={image} className="project-image-link">
                            <img src={image} alt="Project Image" className="project-image" />
                        </a>
                    );
                })}
            </div>
        </div>
    );
}

export function ProjectSection() {
    /*
    const projectData = {
        projectRole: "",
        projectTitle: "",
        techSkills: [],
        projectDescription: "",
        projectLink: "",
        projectImages: [
            "",
        ]
    };
    */
    const LLMChatbotData = {
        projectRole: "SOLE DEVELOPER",
        projectTitle: "Context-Aware LLM Chatbot Platform",
        techSkills: ["Python", "Flask", "FastAPI", "ChromaDB", "MSSQL", "Ollama", "Vanna", "RAG"],
        projectDescription: "Built a <strong>context-aware AI chatbot platform</strong> from scratch featuring dynamic long-term memory, topic drift detection, and an <strong>autonomous LLM agent loop</strong> capable of querying a live database in natural language and running a full <strong>web search RAG pipeline</strong> using only locally hosted models.",
        projectRoute: "/projects/LLMChatbot",
        projectImages: [
            "/images/Project_Images/LLMChatbot/chatbot_ui_thumbnail4.png", 
        ]
    };

    const WarehouseNetworkRackData = {
        projectRole: "SOLE IT TECHNICIAN",
        projectTitle: "Warehouse Network Infrastructure Build",
        techSkills: ["Proxmox", "Docker", "Linux", "UniFi", "Frigate", "NUT/SNMP", "rclone", "Backblaze B2"],
        projectDescription: "Independently researched and deployed a <strong>full network infrastructure stack from scratch</strong> for a workplace warehouse expansion, including LAN configuration, Proxmox virtualization, a UniFi wireless mesh network, a <strong>Frigate NVR security camera system</strong> with cloud backup, and <strong>UPS-integrated graceful shutdown via SNMP</strong>.",
        projectRoute: "/projects/WarehouseNetworkRack",
        projectImages: [
            "/images/Blog_Images/WarehouseNetworkRack/diagrams/network_diagram_td.svg",
        ]
    };

    const TextbookQuizGeneratorData = {
        projectRole: "SOLE DEVELOPER",
        projectTitle: "Textbook Quiz Generator & Autograder",
        techSkills: ["Python", "Flask", "PyMuPDF", "FAISS", "sentence-transformers", "Ollama", "ReportLab", "RAG"],
        projectDescription: "Built a <strong>fully automated quiz generation pipeline</strong> that takes any textbook PDF as input and produces randomized, chapter-specific quizzes with multiple choice, true/false, and short answer questions. Features <strong>textbook-cited answer keys</strong> with confidence scores and <strong>LLM-powered autograding</strong> of free-response questions, all running on a locally hosted Gemma 3 12B model with no external API calls.",
        projectRoute: "/projects/TextbookQuizGenerator",
        projectImages: [
            "/images/Project_Images/TextbookQuizGenerator/pdf/answer_key_pdf.png",
        ]
    };

    const DealershipDatabaseData = {
        projectRole: "DEVELOPER",
        projectTitle: "Car Dealership Manager",
        techSkills: ["MySQL", "PHP", "Apache", "HTML/CSS"],
        projectDescription: "Worked in a team of 4 to create a <strong>web-based database application</strong> designed to help dealerships track vehicle inventory, customer purchases, and sales data efficiently <strong>utilizing a MySQL database</strong>.",
        projectRoute: "/projects/DealershipDatabase",
        projectImages: [
            "/images/Project_Images/DealershipDatabase/add_customer.png",
        ]
    };

    const ULingualData = {
        projectRole: "LEAD BACKEND DEVELOPER",
        projectTitle: "ULingual",
        techSkills: ["JavaScript", "React", "NodeJS", "ExpressJS", "MySQL", "AWS", "Twilio Video API"],
        projectDescription: "Led backend development in a team of 6 to create a <strong>language learning web app</strong> that connects native speakers to exchange language and culture. Implemented the <strong>video chatroom service</strong> using the <strong>Twilio Video API</strong> and <strong>React hooks</strong>.",
        projectRoute: "/projects/ULingual",
        projectImages: [
            "/images/Project_Images/ULingual/ULingual_screenshot_homeSmall.png",
        ]
    };


    const MonopolyData = {
        projectRole: "TEAM LEAD",
        projectTitle: "Monopoly",
        techSkills: ["JavaScript", "PostgreSQL", "NodeJS", "ExpressJS", "Socket.io", "Webpack"],
        projectDescription: "Led a team of 4 to create a multiplayer Monopoly <strong>web app</strong> capible of hosting unlimited games with <strong>live updates</strong> and chat using <strong>WebSockets</strong>.",
        projectRoute: "/projects/Monopoly",
        projectImages: [
            "/images/Project_Images/Monopoly/Monopoly_screenshot_1.png",
        ]
    };

    const SubylertData = {
        projectRole: "HACKATHON TEAM LEAD",
        projectTitle: "Subylert",
        techSkills: ["Android Studio", "Java", "XML", "Firebase", "Room Database", "Notivize API"],
        projectDescription: "<strong>Hackathon winner!</strong> An Android submarine-themed <strong>subscription manager app</strong> that allows users to track their payment subscriptions and receive notifications when a subscription is about to renew.",
        projectRoute: "/projects/Subylert",
        projectImages: [
            "/images/Project_Images/Subylert/Subylert_screenshot_1.png",
        ]
    };


    return (
        <>
            <div className="projects-section" id='Projects'>
                <div className="projects-header">
                    <h1 style={{ display: 'flex', flexDirection: 'row' }}>
                        <div className="highlight">
                            <div>Projects</div>
                            <div></div>
                        </div>
                    </h1>
                </div>

                <div className="projects">
                    <IndividualProject {...WarehouseNetworkRackData} />
                    <IndividualProject {...LLMChatbotData} />
                    <IndividualProject {...TextbookQuizGeneratorData} />
                    <IndividualProject {...DealershipDatabaseData} />
                    <IndividualProject {...ULingualData} />
                    <IndividualProject {...MonopolyData} />
                    <IndividualProject {...SubylertData} />
                </div>
            </div>
        </>
    );
}


export default ProjectSection;